import * as React from 'react';
import {ButtonGroup} from '@packages/systems/design-system/ButtonGroup';
import {dissoc} from '@packages/utilities/key-map';
import type {State} from './LinkTypes';

export const useTarget = (state: State, dispatch: (arg1?: any) => void) => {
  const [target, setTarget] = React.useState(state.target);

  const onChange = React.useCallback(
    (newTarget: string) => {
      // @ts-expect-error - TS2345 - Argument of type 'string' is not assignable to parameter of type 'SetStateAction<"_self" | "_blank" | undefined>'.
      setTarget(newTarget);

      let newState = {...state, target: newTarget};

      // Remove `target` from data when it's `_self`
      if (newTarget === '_self') {
        // @ts-expect-error - TS2739 - Type '{ [key: string]: any; }' is missing the following properties from type '{ target: string; mode: Mode; url?: string | undefined; pageId?: string | undefined; domId?: string | undefined; email?: string | undefined; subject?: string | undefined; tel?: string | undefined; assetId?: string | undefined; preload?: "none" | ... 2 more ... | undefined; }': target, mode
        newState = dissoc('target')(newState);
      }

      dispatch({
        payload: newState,
        meta: {
          analytics: {type: 'element-settings-updated', value: 'link target'},
        },
      });
    },
    [dispatch, state, setTarget]
  );

  React.useEffect(() => {
    // When `target` is undefined we goahead and set the state to show the
    // associated UI.
    if (state.target === undefined) {
      setTarget('_self');
    } else if (state.target !== target) {
      setTarget(state.target);
    }
  }, [state.target, target]);

  return {onChange, target};
};

const targetOptions = [
  {
    value: '_self',
    label: 'This tab',
  },
  {
    value: '_blank',
    label: 'New tab',
  },
];

export const LinkTarget = ({
  state,
  dispatch,
}: {
  state: State;
  dispatch: (arg1?: any) => void;
}) => {
  const {target = '_self', onChange} = useTarget(state, dispatch);

  return (
    <ButtonGroup
      data-automation-id="Type--Plugin_Enum_Open in_buttons"
      onChange={onChange}
      radiogroup
      options={targetOptions}
      value={target}
    />
  );
};
